(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6993],{

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 61827:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gc": function() { return /* binding */ FullPageGrid_e; }
});

// UNUSED EXPORTS: Bleed, Col, default

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/constants.mjs
var constants = __webpack_require__(55287);
;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Grid/gridConstants.mjs
const e = {
  SMALL: "1rem",
  MEDIUM: "2rem",
  LARGE: "2rem"
}, r = {
  SMALL: "1rem",
  MEDIUM: "2rem",
  LARGE: "4rem"
};


// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Grid/Bleed.mjs





const s = (o, m) => {
  const l = typeof m == "object" ? {
    small: !1,
    medium: !1,
    large: !1,
    ...m
  } : {
    small: m,
    medium: m,
    large: m
  };
  return [
    l.small && emotion_react_browser_esm/* css */.iv`
                @media (max-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) {
                  margin-${o}: -${r.SMALL};
                }
            `,
    l.medium && emotion_react_browser_esm/* css */.iv`
                @media (min-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) and (max-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
                  margin-${o}: -${r.MEDIUM};
                }
            `,
    l.large && emotion_react_browser_esm/* css */.iv`
                @media (min-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
                  margin-${o}: -${r.LARGE};
                }
            `
  ];
}, c = "div", i = ({
  component: o,
  left: m,
  right: l,
  children: n,
  ...p
}) => {
  const f = o || c, d = [...s("left", m), ...s("right", l)];
  return /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(f, { ...p, css: d, children: n });
};
i.propTypes = {
  /** Component type used to render the bleeding */
  component: prop_types.oneOfType([prop_types.string, prop_types.element]),
  /** Enable left side bleed over the grid padding, for all screen widths,
   * or specific for small, medium or large */
  left: prop_types.oneOfType([
    prop_types.bool,
    prop_types.shape({
      small: prop_types.bool,
      medium: prop_types.bool,
      large: prop_types.bool
    })
  ]),
  /** Enable right side bleed over the grid padding, for all screen widths,
   * or specific for small, medium or large */
  right: prop_types.oneOfType([
    prop_types.bool,
    prop_types.shape({
      small: prop_types.bool,
      medium: prop_types.bool,
      large: prop_types.bool
    })
  ])
};
const M = i;


;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Grid/Col.mjs





const h = (n, m) => {
  let s = null, t = null;
  if (typeof n == "object") {
    const { small: l = 2, medium: r = 6, large: o = 12 } = n;
    s = {
      small: l > 2 ? 2 : l < 1 ? 1 : l,
      medium: r > 6 ? 6 : r < 1 ? 1 : r,
      large: o > 12 ? 12 : o < 1 ? 1 : o
    };
  } else {
    const l = n > 12 ? 12 : n < 1 ? 1 : n;
    s = {
      small: Math.round(2 * l / 12) || 1,
      medium: Math.round(6 * l / 12) || 1,
      large: l
    };
  }
  if (typeof m == "object") {
    const { small: l, medium: r, large: o } = m;
    t = {
      small: l > 2 ? 2 : l < 0 ? 0 : l,
      medium: r > 6 ? 6 : r < 0 ? 0 : r,
      large: o > 12 ? 12 : o < 0 ? 0 : o
    };
  } else if (m) {
    const l = m > 12 ? 12 : m < 0 ? 0 : m, r = Math.floor(2 * l / 12), o = Math.floor(6 * l / 12);
    t = {
      small: r < 1 ? 1 : r,
      medium: o < 1 ? 1 : o,
      large: l
    };
  } else
    t = {
      small: null,
      medium: null,
      large: null
    };
  return {
    sizes: s,
    columnStarts: t
  };
}, $ = (n) => {
  const m = typeof n == "object" ? {
    small: null,
    medium: null,
    large: null,
    ...n
  } : {
    small: n,
    medium: n,
    large: n
  };
  return [
    m.small && emotion_react_browser_esm/* css */.iv`
                @media (max-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) {
                    grid-row: ${m.small};
                }
            `,
    m.medium && emotion_react_browser_esm/* css */.iv`
                @media (min-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) and (max-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
                    grid-row: ${m.medium};
                }
            `,
    m.large && emotion_react_browser_esm/* css */.iv`
                @media (min-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
                    grid-row: ${m.large};
                }
            `
  ].filter(Boolean);
}, y = (n, m) => [
  emotion_react_browser_esm/* css */.iv`
            grid-column-end: span ${n.small};

            @media (min-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) {
                grid-column-end: span ${n.medium};
            }
            @media (min-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
                grid-column-end: span ${n.large};
            }
        `,
  m.small && emotion_react_browser_esm/* css */.iv`
                @media (max-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) {
                    grid-column-start: ${m.small};
                }
            `,
  m.medium && emotion_react_browser_esm/* css */.iv`
                @media (min-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) and (max-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
                    grid-column-start: ${m.medium};
                }
            `,
  m.large && emotion_react_browser_esm/* css */.iv`
                @media (min-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
                    grid-column-start: ${m.large};
                }
            `
], Col_M = "div", p = ({
  size: n = 1,
  columnStart: m,
  gridRow: s,
  component: t,
  bleedLeft: l,
  bleedRight: r,
  ...o
}) => {
  const { sizes: f, columnStarts: b } = h(n, m), d = [...y(f, b), ...$(s)], u = t || Col_M;
  return l || r ? /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(M, { component: u, ...o, css: d, left: l, right: r }) : /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(u, { ...o, css: d });
};
p.propTypes = {
  /** Component type used to render the column */
  component: prop_types.oneOfType([prop_types.string, prop_types.element]),
  /** Column start either for all screen widths or for a specific breakpoint.
   * If the columnStart is specified for all screen widths, the value is normalized to match
   * each breakpoint (maximum 2 for small, 6 for medium, 12 for large). */
  columnStart: prop_types.oneOfType([
    prop_types.number,
    prop_types.shape({
      small: prop_types.number,
      medium: prop_types.number,
      large: prop_types.number
    })
  ]),
  /** Grid row style for all screen widths or for a specific breakpoint.
   * Supports a number or native grid-row css values. */
  gridRow: prop_types.oneOfType([
    prop_types.string,
    prop_types.number,
    prop_types.shape({
      small: prop_types.oneOfType([prop_types.string, prop_types.number]),
      medium: prop_types.oneOfType([prop_types.string, prop_types.number]),
      large: prop_types.oneOfType([prop_types.string, prop_types.number])
    })
  ]),
  /** Enable left side bleed over the grid padding, for all screen widths,
   * or specific for small, medium or large */
  bleedLeft: prop_types.oneOfType([
    prop_types.bool,
    prop_types.shape({
      small: prop_types.bool,
      medium: prop_types.bool,
      large: prop_types.bool
    })
  ]),
  /** Enable right side bleed over the grid padding, for all screen widths,
   * or specific for small, medium or large */
  bleedRight: prop_types.oneOfType([
    prop_types.bool,
    prop_types.shape({
      small: prop_types.bool,
      medium: prop_types.bool,
      large: prop_types.bool
    })
  ]),
  /** Column width for all screen widths, or specific for small, medium or large.
   * If the size is specified for all screen widths, the value is normalized to match
   * each breakpoint (maximum 2 for small, 6 for medium, 12 for large) */
  size: prop_types.oneOfType([
    prop_types.number,
    prop_types.shape({
      small: prop_types.number,
      medium: prop_types.number,
      large: prop_types.number
    })
  ])
};
const x = p;


;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Grid/Grid.mjs







const Grid_i = {
  grid: emotion_react_browser_esm/* css */.iv`
        display: grid;
        grid-template-columns: [start] minmax(0, 1fr) [first-col-end middle last-col-start] minmax(0, 1fr) [end];
        grid-column-gap: ${e.SMALL};

        @media (min-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) {
            grid-template-columns:
                [start] minmax(0, 1fr) [first-col-end] repeat(2, minmax(0, 1fr)) [middle] repeat(
                    2,
                    minmax(0, 1fr)
                )
                [last-col-start] minmax(0, 1fr) [end];
            grid-column-gap: ${e.MEDIUM};
        }
        @media (min-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
            grid-template-columns:
                [start] minmax(0, 1fr) [first-col-end] repeat(5, minmax(0, 1fr)) [middle] repeat(
                    5,
                    minmax(0, 1fr)
                )
                [last-col-start] minmax(0, 1fr) [end];
            grid-column-gap: ${e.LARGE};
        }
    `,
  rowGutter: emotion_react_browser_esm/* css */.iv`
        grid-row-gap: ${e.SMALL};

        @media (min-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) {
            grid-row-gap: ${e.MEDIUM};
        }
    `
}, Grid_c = "div", t = ({
  children: n,
  component: a,
  hasRowGutter: d = !1,
  ...s
}) => /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(a || Grid_c, { ...s, css: [Grid_i.grid, d && Grid_i.rowGutter], children: n });
t.propTypes = {
  /** Component type used to render the column */
  component: prop_types.oneOfType([prop_types.string, prop_types.element]),
  children: prop_types.oneOfType([prop_types.node, prop_types.arrayOf(prop_types.node)]).isRequired,
  /** Enable row gutter */
  hasRowGutter: prop_types.bool
};
t.Col = x;
t.Bleed = M;
const L = e.SMALL;


;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Grid/FullPageGrid.mjs








const d = {
  fullPage: emotion_react_browser_esm/* css */.iv`
        max-width: 1440px;
        margin: auto;
        width: 100%;
        box-sizing: border-box;
    `,
  padding: emotion_react_browser_esm/* css */.iv`
        padding-left: ${r.SMALL};
        padding-right: ${r.SMALL};

        @media (min-width: ${constants/* BREAKPOINTS.MEDIUM */.j$.MEDIUM}rem) {
            padding-left: ${r.MEDIUM};
            padding-right: ${r.MEDIUM};
        }

        @media (min-width: ${constants/* BREAKPOINTS.LARGE */.j$.LARGE}rem) {
            padding-left: ${r.LARGE};
            padding-right: ${r.LARGE};
        }
    `
}, FullPageGrid_s = "div", FullPageGrid_e = ({
  children: m,
  component: n,
  ...p
}) => /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(t, { component: n || FullPageGrid_s, ...p, css: [d.fullPage, d.padding], children: m });
FullPageGrid_e.propTypes = {
  children: prop_types.oneOfType([prop_types.node, prop_types.arrayOf(prop_types.node)]),
  /** Enable row gutter */
  hasRowGutter: prop_types.bool
};
FullPageGrid_e.Col = x;
FullPageGrid_e.Bleed = M;



/***/ }),

/***/ 38833:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var _theme_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67717);



const p = ({ fill: o, ...r }) => {
  const t = (0,_theme_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .Fg)();
  return /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: o || t.colors.foreground,
      ...r,
      children: /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5868 12.0028L4.00444 18.5894L5.4182 20.0041L12.0009 13.4172L18.5831 20.0009L19.9972 18.5865L13.4147 12.0025L19.9983 5.41467L18.5845 4L12.0006 10.5882L5.41406 4.00015L4 5.41452L10.5868 12.0028Z"
        }
      )
    }
  );
};
p.propTypes = {
  fill: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};



/***/ }),

/***/ 44703:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ i; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var _theme_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67717);



const i = ({ fill: r, ...t }) => {
  const e = (0,_theme_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .Fg)();
  return /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: r || e.colors.foreground,
      ...t,
      children: /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", { d: "M15 13.75V19H18V12V5H15V10.25L6 5V19L15 13.75Z" })
    }
  );
};
i.propTypes = {
  fill: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};



/***/ }),

/***/ 33501:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var _theme_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67717);



const p = ({ fill: o, ...r }) => {
  const t = (0,_theme_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .Fg)();
  return /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: o || t.colors.foreground,
      ...r,
      children: /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 5H7V19H10V5ZM17 5H14V19H17V5Z" })
    }
  );
};
p.propTypes = {
  fill: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};



/***/ }),

/***/ 9554:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ i; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var _theme_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67717);



const i = ({ fill: r, ...t }) => {
  const e = (0,_theme_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .Fg)();
  return /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: r || e.colors.foreground,
      ...t,
      children: /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", { d: "M20 12L8 5V19L20 12Z" })
    }
  );
};
i.propTypes = {
  fill: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};



/***/ }),

/***/ 80937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ d; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/constants.mjs
var constants = __webpack_require__(55287);
;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Media/Waveform/WaveformPainter.mjs
var a = Object.defineProperty;
var g = (l, t, i) => t in l ? a(l, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : l[t] = i;
var h = (l, t, i) => (g(l, typeof t != "symbol" ? t + "" : t, i), i);
class c {
  constructor(t, i, o, e, s, r) {
    h(this, "samples");
    h(this, "waveform_canvas");
    h(this, "width");
    h(this, "height");
    h(this, "fillColor");
    h(this, "strokeColor");
    h(this, "progressColor");
    h(this, "highlightColor");
    this.samples = i, this.waveform_canvas = t, this.width = t.width, this.height = t.height, this.fillColor = o, this.strokeColor = e, this.progressColor = s, this.highlightColor = r;
  }
  getNormalizationFactor() {
    return this.height / (2 * 128);
  }
  drawWaveform() {
    const t = this.waveform_canvas.getContext("2d");
    t.globalCompositeOperation = "source-over", t.strokeStyle = this.strokeColor || "rgb(65,65,65)", t.fillStyle = this.fillColor || "rgb(95, 95, 95)", t.beginPath(), t.moveTo(0, this.height / 2), t.lineTo(this.width, this.height / 2), t.stroke();
    let i = 0;
    const o = 1, e = -1 * this.getNormalizationFactor();
    t.beginPath(), t.moveTo(0, this.height / 2);
    for (let s = 0; s < this.samples.length; s += 2 * o)
      i += o, t.lineTo(i, this.height / 2 + e * this.samples[s]);
    for (let s = this.samples.length - 1; s > 0; s -= 2 * o)
      i -= o, t.lineTo(i, this.height / 2 + e * this.samples[s]);
    t.stroke(), t.fill();
  }
  drawProgress(t) {
    this.clearProgress();
    const i = this.waveform_canvas.getContext("2d");
    i.globalCompositeOperation = "source-atop", i.fillStyle = this.progressColor, i.fillRect(0, 0, this.width * t, this.height);
  }
  drawHighlight(t, i) {
    this.clearProgress();
    const o = this.waveform_canvas.getContext("2d");
    o.globalCompositeOperation = "source-atop", o.fillStyle = this.highlightColor, o.fillRect(t, 0, i, this.height);
  }
  drawBoth({ start: t, end: i, progress: o }) {
    this.clearProgress();
    const e = this.waveform_canvas.getContext("2d");
    e.globalCompositeOperation = "source-atop", t !== void 0 && i !== void 0 && (e.fillStyle = this.highlightColor, e.fillRect(t, 0, i, this.height)), o !== void 0 && (e.fillStyle = this.progressColor, e.fillRect(0, 0, this.width * o, this.height));
  }
  clearProgress() {
    const t = this.waveform_canvas.getContext("2d");
    t.globalCompositeOperation = "source-atop", t.fillStyle = this.fillColor, t.fillRect(0, 0, this.width, this.height);
  }
  clear() {
    const t = this.waveform_canvas.getContext("2d");
    t.clearRect(0, 0, this.width, this.height), t.beginPath(), t.moveTo(0, this.height / 2), t.lineTo(this.width, this.height / 2), t.stroke();
  }
}
const WaveformPainter_f = c;


;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Media/Waveform/Waveform.mjs






const y = 1600, O = 35, v = "#414141", Waveform_g = {
  canvas: (e) => emotion_react_browser_esm/* css */.iv`
        width: 100%;
        height: ${e}px;
    `
}, Waveform_c = ({
  waveformData: e,
  fillColor: a = v,
  strokeColor: f = v,
  progressColor: o = constants/* COLORS_RAW.WHITE */.HJ.WHITE,
  highlightColor: m = constants/* COLORS_RAW.GRAY_2 */.HJ.GRAY_2,
  onLoad: t,
  height: i = O,
  onClick: l
}) => {
  const n = (0,react.useRef)(null), s = (0,react.useRef)(null);
  return (0,react.useEffect)(() => {
    n.current && (s.current = new WaveformPainter_f(
      n.current,
      e || Array(1e3),
      a,
      f,
      o,
      m
    ), s.current.clear(), s.current.drawWaveform(), t == null || t(s.current));
  }, [a, o, f, m, e, t]), /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(
    "canvas",
    {
      id: "waveform-canvas",
      ref: n,
      width: y,
      height: i,
      css: Waveform_g.canvas(i),
      onClick: l
    }
  );
};
Waveform_c.displayName = "Waveform";
Waveform_c.propTypes = {
  waveformData: prop_types.arrayOf(prop_types.number),
  fillColor: prop_types.string,
  strokeColor: prop_types.string,
  progressColor: prop_types.string,
  highlightColor: prop_types.string,
  onLoad: prop_types.func.isRequired,
  height: prop_types.number,
  onClick: prop_types.func
};
const d = Waveform_c;



/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 76166:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 82662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 28668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 44998:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 25892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _wrapNativeSuper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(44998);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}


/***/ })

}]);